import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import EarLobeImage from '../../Assets/Piercing Services/ear lobe piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function EarlobePiercing() {
  return (
    <div>
        <div className="earlobe-container">

        <Helmet>
            <title>Ear Lobe Piercing Dubai, UAE</title>
            <meta
                name="description"
                content="Ear Lobe Piercing Dubai, UAE with high-standard hygiene, quality piercing products and expert care at a trusted piercing studio."
            />
        </Helmet>

        {/* Floating Buttons */}
        <div className="floating-buttons">
            <div 
            className='whatsapp-button' 
            onClick={() => handleWhatsAppClick("I am interested in Ear Lobe Piercing")}
            >
            <img src={whatsapp} alt="WhatsApp" />
            </div>

            <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
            </a>
        </div>

        {/* Heading */}
        <h1 className="earlobe-title">
            Ear Lobe Piercing 100-125 AED
        </h1>

        {/* Image */}
        <div className="earlobe-image-wrapper">
            <img src={EarLobeImage} alt="Ear Lobe Piercing" />
        </div>

        {/* Description */}
        <div className="earlobe-content">
            <h3>Ear Lobe Piercing</h3>

            <p>
                Enhance your look with our professional ear lobe piercing services in the UAE, available at an affordable price range of 100–125 AED. Ear lobe piercing is a classic and widely popular choice, performed on the lower part of the ear lobe, making it ideal for both first-time clients and those looking to add a subtle yet stylish touch to their appearance. Our expert specialists are highly trained to deliver precise and pain-minimized ear piercing using sterile, high-quality, single-use equipment that ensures maximum safety and hygiene throughout the procedure.
            </p>

            <p>
                We prioritize your comfort and well-being by maintaining strict hygiene standards and following professional piercing protocols. Each ear lobe piercing is performed in a clean, sanitized environment to reduce the risk of infection and ensure a smooth experience. Whether you are getting your ears pierced for the first time or upgrading your style with additional piercings, our team provides personalized care tailored to your needs. We take the time to understand your preferences, guide you on the best placement, and ensure that the piercing complements your look perfectly.
            </p>

            <p>
                Our ear lobe piercing service is suitable for both kids and adults, making it a versatile and convenient option for anyone looking to express their style. The procedure is quick and gentle, typically completed within minutes, with minimal discomfort. Our specialists use advanced techniques designed to reduce pain and promote faster healing, ensuring that you can enjoy your new piercing without any hassle. We also offer high-quality, hypoallergenic starter earrings that are safe for sensitive skin, helping to prevent irritation and allergic reactions.
            </p>

            <p>
                Aftercare plays a crucial role in maintaining the health of your piercing, and we provide detailed guidance to help you through the healing process. Our team will explain how to clean your piercing properly, what precautions to take, and how to avoid common issues such as infections or irritation. With the right care, ear lobe piercings heal quickly and remain a long-lasting and stylish addition to your overall look.
            </p>

            <p>
                Our services are designed to combine affordability with premium quality, making professional ear lobe piercing accessible across the UAE. We offer transparent pricing with no hidden costs, ensuring you receive excellent value for your money. Booking your appointment is simple and convenient, allowing you to choose a time that fits your schedule. We strive to minimize waiting times and provide a seamless experience from start to finish.
            </p>

            <p>
                Choosing our ear lobe piercing services in the UAE means trusting experienced professionals who are dedicated to safety, precision, and customer satisfaction. From our hygienic practices and skilled specialists to our welcoming environment and personalized approach, every aspect of our service is designed to give you confidence and peace of mind. Book your ear lobe piercing appointment today and enjoy a safe, stylish, and hassle-free experience that enhances your look with timeless elegance.
            </p>

            <button 
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Ear Lobe Piercing")}
            >
            Book Now
            </button>
        </div>

        </div>
        <Footer/>
    </div>

  );
}

export default EarlobePiercing;